import { Component, OnInit, inject } from '@angular/core';
import { MAT_OVERLAY_DATA, OverlayPopupRef } from '../../../core';


@Component({
    selector: 'app-package-overlay',
    templateUrl: './package-overlay.component.html',
    styleUrls: ['./package-overlay.component.scss']
})
export class PackageOverlayComponent implements OnInit {
  dialogRef = inject<OverlayPopupRef<PackageOverlayComponent>>(OverlayPopupRef);
  inputdata = inject<[
]>(MAT_OVERLAY_DATA);

  packagefolder: any;
  
  ngOnInit(): void {
    this.packagefolder = this.inputdata;
  }
}